import { ChangeDetectionStrategy, Component, HostBinding, Input, ViewEncapsulation } from "@angular/core";
import { UiInteraction } from "@obg/ngx.core";
import { Icon } from "@obg/ngx.core.content";

@Component({
	selector: "obg-icon-list",
	templateUrl: "./icon-list.component.html",
	styleUrls: ["./icon-list.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	encapsulation: ViewEncapsulation.None,
})
export class IconListComponent {
	/**
	 * A list of icons
	 */
	@Input() icons: Icon[] = [];
	/**
	 * A string to be shown as a title for the section
	 */
	@Input() titleText: string | undefined;
	/**
	 * ui interaction event data
	 */
	@Input() uiInteraction: UiInteraction | undefined;

	@Input() titleEnabled = true;

	@Input() iconEnabled = false;

	@Input() titleIconImageKey: string | undefined;

	@Input() realmStyling: { class?: string; span?: string } | undefined;

	@HostBinding("class.obg-icon-list") hostCssClass = true;

	trackByIcon(_index: number, icon: Icon): string {
		return icon.key;
	}
}
